import { animate, style, transition, trigger } from "@angular/animations";
import { Component, inject, OnInit, ViewChild } from "@angular/core";
import { AppConfigService } from "./app.config.service";
import { SidenavService } from "@services/sidenav.service";
import { MatSidenav, MatSidenavModule } from "@angular/material/sidenav";
import { RouterOutlet } from "@angular/router";
import { CdkPortalOutlet } from "@angular/cdk/portal";
import { AsyncPipe, NgStyle } from "@angular/common";
import { BillingBlockRedirectService } from "@services/platform-alerts/billing-block-redirect.service";

@Component({
    selector: "app-root",
    animations: [
        trigger("enterAnimation", [
            transition(":leave", [
                style({ transform: "translateY(100%)", opacity: 1 }),
                animate(
                    "300ms",
                    style({ transform: "translateY(0)", opacity: 0 }),
                ),
            ]),
        ]),
    ],
    imports: [
        AsyncPipe,
        MatSidenavModule,
        NgStyle,
        RouterOutlet,
        CdkPortalOutlet,
    ],
    templateUrl: "./app.component.html",
    styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit {
    @ViewChild("globalSidenav", { static: false })
    private globalSidenav: MatSidenav;

    private readonly billingBlockRedirect = inject(BillingBlockRedirectService);

    constructor(
        private readonly appConfig: AppConfigService,
        public readonly sidenavService: SidenavService,
    ) {
        window.name = "Atom";
    }

    async ngOnInit(): Promise<void> {
        await this.appConfig.load();
        this.appConfig.setGoogleApiScript();
        this.sidenavService.sidenav = this.globalSidenav;
        this.billingBlockRedirect.start();
    }
}
